import isMobile from "../plugins/is-mobile.js";

const target = document.querySelector("#main-video");

// if (isMobile(520)) {
//   target.setAttribute("src", target.getAttribute("src").replace("pc", "sp"));
// }


// if(isMobile(1029)) {
//   $(window).on('resize', function(){
//     var w = $(window).width();
//     var h = $(window).height();

//     var r_w = h * 16 / 9;
//     var r_h = $(window).width() * 9/16;

//     var mr = (r_w - w) /2;

//     if(h > r_h) {
//       $('#main-video').css({
//         'width': r_w + "px",
//         'height': h + "px",
//         'margin-left': -mr + "px"
//       });
//     } else {
//       $('#main-video').css({
//         'width': 100 + "%",
//         'height': "auto"
//       });
//     }
//   }).trigger('resize');
// }